module.exports = __webpack_public_path__ + "static/media/125.250220f5.png";